export enum ProjectAction {
    NewStore = 1,
    Rebuild = 2
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_entities/project-action.ts